import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12","key":"svg-0"}],["path",{"d":"M15 4v1","key":"svg-1"}],["path",{"d":"M15 9v1","key":"svg-2"}],["path",{"d":"M15 14v1","key":"svg-3"}],["path",{"d":"M15 19v1","key":"svg-4"}]]

const IconLayoutSidebarRightInactive = createReactComponent('outline', 'layout-sidebar-right-inactive', 'LayoutSidebarRightInactive', __iconNode);

export default IconLayoutSidebarRightInactive;